const getters = {
    measureUnits: state => state.measure_units,
    measureUnit: state => state.measure_unit,
    measureUnitFilters: state => state.measure_unit_filters,
}

export default getters;
